import { baseApi } from './baseApi'
import { IGeneralInfo } from '../../types/app'

export const generalInfoApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getInfo: builder.query<IGeneralInfo, void>({
      query: () => '/general-info',
      providesTags: ['GeneralInfo'],
    }),
    editInfo: builder.mutation<{ images: string[] }, FormData>({
      query: (formData) => ({
        url: '/general-info',
        method: 'PUT',
        body: formData,
      }),
      invalidatesTags: ['GeneralInfo'],
    }),
    deleteImage: builder.mutation<void, string>({
      query: (imageUrl) => ({
        url: `/general-info?imageUrl=${imageUrl}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['GeneralInfo'],
    }),
    updateRouletteStatus: builder.mutation<
      void,
      { isRouletteActive: boolean; rouletteMinPrice: number }
    >({
      query: ({ isRouletteActive, rouletteMinPrice }) => ({
        url: '/general-info/roulette',
        method: 'PATCH',
        body: { isRouletteActive, rouletteMinPrice },
      }),
      invalidatesTags: ['GeneralInfo'],
    }),
  }),
})

export const {
  useGetInfoQuery,
  useEditInfoMutation,
  useDeleteImageMutation,
  useUpdateRouletteStatusMutation,
} = generalInfoApi
